
import AppLink from "./AppLink"
import AppButton from "../components/AppButton"
import stubDirectives from "../mixins/stubDirectives"
import buttonProps from "../helpers/buttonProps"
import Article from "./Article.vue"

export default {
  components: {
    AppLink,
    AppButton,
    Article
  },
  mixins: [stubDirectives],
  props: {
    iconText: {
      type: Array,
      required: true
    },
    variant: {
      type: String,
      default: null,
      validator(value) {
        return ["dark", "yellow", "grey", "night"].includes(value)
      }
    },
    displayAsColumn: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    noEllipse: {
      type: Boolean,
      default: false
    },
    centerTextVertically: {
      type: Boolean,
      default: false
    },
    displayDense: {
      type: Boolean,
      default: false
    },
    separatorLine: {
      type: Boolean,
      default: false
    },
    button: {
      type: Array,
      default: () => []
    },
    bottomArticle: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    variantClass() {
      switch (this.variant) {
        case "dark":
          return "--is-dark"
        case "yellow":
          return "--is-yellow"
        case "grey":
          return "--is-grey"
        case "night":
          return "--is-night"
        default:
          return ""
      }
    },
    buttonProps() {
      return buttonProps(this.button)
    },
    isEven() {
      return this.iconText.length % 2 === 0
    },
    bottomArticleData() {
      return this.bottomArticle?.[0]?.textContent ?? {}
    }
  }
}
